import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import React from 'react';
import { useAction } from 'hooks/useAction';
import FormGroup from 'components/Form/FormGroup';
import App from 'modules/App';
import Input from 'components/Form/Input';
import { SIGN_UP_FORM } from '../../../../constants';
import messages from '../../../../messages';
import styles from '../../SignUp.pcss';
import { useIsMinor } from '../hooks';
import useGuardianConsentsEmailEffects from './useGuardianConsentsEmailEffects';
const GuardianConsentsEmail = ()=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const setFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    useGuardianConsentsEmailEffects();
    const isMinor = useIsMinor();
    if (!isMinor) return null;
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "guardianEmail",
        labelMessage: messages.labels.guardianEmail,
        formValues: formValues,
        infoMessage: messages.infos.guardianEmail,
        className: styles.guardianConsentsEmail,
        children: /*#__PURE__*/ _jsx(Input, {
            placeholder: messages.placeholders.guardianEmail,
            onChange: setFormValue
        })
    });
};
export default GuardianConsentsEmail;
